<template>
    <div class="viewpoints-wrap">
        <Title>
            <h2>Viewpoints</h2>
            <span @click="search" class="ico-search"><svg><use xlink:href="#search--sprite"></use></svg></span>
        </Title>

        <Categories :categories="categories" />

        <div class="page-inner">
            <Content v-if="page">
                <div class="box" v-html="page"></div>
            </Content>

            <List v-if="posts.length !== 0">
                <Item v-for="(item, index) in posts" :key="item.id + '-' + index" :item="item" />
            </List>

            <Loading v-if="$store.state.is_loading" class="static" />
            
            

            <NoResults v-if="posts.length === 0 && !$store.state.is_loading">
                No posts ...
            </NoResults>


        </div>
    </div>
</template>
<script>

import Title from '@/components/ui/Title.vue';
import Content from '@/components/ui/Content.vue';
import List from '@/components/ui/List.vue';
import NoResults from '@/components/ui/NoResults.vue';
import Categories from '@/components/Categories.vue';
import Item from '@/components/Item.vue';
import Loading from '@/components/Loading.vue';

export default {
    name: 'viewpoints',

    data () {
        return {
            page: false,
            posts: [],
            categories: [],
            paged: 1,
            per_page: 999,
            is_end: false,
        }
    },

    components: {
        Title,
        Content,
        List,
        Item,
        Categories,
        Loading,
        NoResults,
    },

    watch: {
        '$route.params': {
            handler(params) {
                this.fetchData(params);
            },

            immediate: true,
        }
    },

    methods: {
        search() {
            this.$store.state.back_url = this.$route.path
            this.$router.push({
                path: '/search',
            });
            
        },
       getPosts(is_next = false) {
            
            
            if (!is_next) {
                this.paged = 1;
                this.posts = [];
                this.is_end = false;

            } 
            else if (this.is_end) return;
            else this.paged ++;

            this.$store.state.is_loading = true;

            let url = `get-viewpoints?per_page=${this.per_page}&paged=${this.paged}`;

            if (this.$route.name === 'viewpoints-category') {
                url = url + '&category=' + this.$route.params.slug;
            }

            this.$ajax.get(url).then(res => {
                if (is_next) {
                    res.data.forEach(item => {
                        this.posts.push(item);
                    });
                } else {
                    this.posts = res.data;
                }
                
                this.$store.state.is_loading = false;
                this.is_end = (res.data.length < this.per_page);
            }).catch((error) => {
                // console.log(error)
                this.is_end = true;

            });
        },

        fetchData(params) {
            console.log(this.$route)

            // this.page = false;
            // this.current_page_id = false;
            // if (this.$route.name === 'viewpoints-category') {
            //     url = url + '&category=' + this.$route.params.slug;
            // }
            
            // this.$ajax.get('pages?slug=viewpoints').then(res => {
            //     this.page = res.data[0];

            //     document.title = window.globals.site_title + ' — ' + this.$decode(res.data[0].title.rendered);

            // });
            

            this.$ajax.get('/categories').then(res => {
                this.categories = res.data;

                res.data.forEach(item => {
                    if (item.slug === this.$route.params.slug) {
                        this.page = item.description;
                        document.title = window.globals.site_title + ' — ' + item.name;
                    }
                    
                });

            });

            this.getPosts();

        },

    },




}
</script>

<style lang="scss">

    .shop-wrap {
        .ui-enter {
            padding: 0 var(--padding) 0;

            h2 {
                margin-bottom: var(--padding-50);
            }
        }

        .ui-list {
            margin-top: var(--padding-50);
            padding: 0 var(--padding-50);
        }

        .load-more {
            text-align: center;
            padding: 0 var(--padding) var(--padding-x2);
            min-height: 3rem;

            span {
                cursor: pointer;
            }
        }
    }


</style>